import { RolesPerService } from "model/roles"
import { User } from "model/user"
import {
    ADD_ROLE,
    REMOVE_ROLE,
    SAVE_USER,
    SAVING_USER,
    SAVING_USER_ABORTED,
    SEARCH_ABORTED,
    SEARCH_DONE,
    SEARCH_USERS,
    SEARCHING_USERS,
    SELECT_USER,
    SET_USER_PROPERTY,
    USER_SAVED,
} from "./action_types"

export type ADD_ROLE_ACTION = {
    type: typeof ADD_ROLE
    claim_name: string
    role_name: string
    roles_per_service: RolesPerService
}

export const addRole = (
    claim_name: string,
    role_name: string,
    roles_per_service: RolesPerService
): ADD_ROLE_ACTION => ({
    type: ADD_ROLE,
    claim_name,
    role_name,
    roles_per_service,
})

export type REMOVE_ROLE_ACTION = {
    type: typeof REMOVE_ROLE
    claim_name: string
    role_name: string
    roles_per_service: RolesPerService
}

export const removeRole = (
    claim_name: string,
    role_name: string,
    roles_per_service: RolesPerService
): REMOVE_ROLE_ACTION => ({
    type: REMOVE_ROLE,
    claim_name,
    role_name,
    roles_per_service,
})

export type SELECT_USER_ACTION = {
    type: typeof SELECT_USER
    user_id: string
}

export const selectUser = (user_id: string): SELECT_USER_ACTION => ({
    type: SELECT_USER,
    user_id: user_id,
})

export type SEARCH_ACTION = {
    type: typeof SEARCH_USERS
}

export const search = (): SEARCH_ACTION => ({
    type: SEARCH_USERS,
})

export type SAVE_USER_ACTION = {
    type: typeof SAVE_USER
}

export const save = (): SAVE_USER_ACTION => ({
    type: SAVE_USER,
})

export type SET_USER_PROPERTY_ACTION = {
    type: typeof SET_USER_PROPERTY
    propertyPath: string[]
    value: any
}

export const setProperty = (propertyPath: string[], value: any): SET_USER_PROPERTY_ACTION => ({
    type: SET_USER_PROPERTY,
    propertyPath: propertyPath,
    value: value,
})

export type SEARCHING_USERS_ACTION = {
    type: typeof SEARCHING_USERS
}

export type SEARCH_ABORTED_ACTION = {
    type: typeof SEARCH_ABORTED
}

export type SEARCH_DONE_ACTION = {
    type: typeof SEARCH_DONE
    users: User[]
    total: number
}

export type SAVING_USER_ACTION = {
    type: typeof SAVING_USER
}

export type SAVING_USER_ABORTED_ACTION = {
    type: typeof SAVING_USER_ABORTED
}

export type USER_SAVED_ACTION = {
    type: typeof USER_SAVED
    user: User
}
